import FollowUpCard from './FollowUpCard'
import LeadsManagementCard from './LeadsManagementCard'

export default function DashboardLeadsSection({
  leadsManagement,
  leadsNotFollowedUp = [],
  period,
  customRange,
}) {
  return (
    <section className="grid items-stretch gap-4 xl:grid-cols-[minmax(280px,340px)_1fr]">
      <LeadsManagementCard
        data={leadsManagement}
        period={period}
        customRange={customRange}
      />
      <FollowUpCard data={leadsNotFollowedUp} />
    </section>
  )
}
